$(function () {

  $('.accordion-list > li > .accordion-list__content').hide();
    
  $('.accordion-list > li').click(function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active").find(".accordion-list__content").slideUp();
    } else {
      $(".accordion-list > li.active .accordion-list__content").slideUp();
      $(".accordion-list > li.active").removeClass("active");
      $(this).addClass("active").find(".accordion-list__content").slideDown();
    }
    return false;
  });
  // Override for any button that may be included in the section
  $(".accorion-list__button a").click(function(e){
    e.stopPropagation();
  })
});